import { Box } from '@mui/material';

import useLoginContext from '@/context/LoginFlowContextProvider/useLoginContext';

import { NoActionsHeader, NoActionsHeaderSubtitle } from './NoQuickActionStyle';

const NoQuickAction = () => {
  const { currentUser } = useLoginContext();
  return currentUser ? (
    <NoActionsHeader>
      <Box>
        <span role="img" aria-label="emoji" style={{ fontSize: '32px' }}>
          🙌
        </span>
      </Box>
      <Box>
        <NoActionsHeaderSubtitle>That's all for now!</NoActionsHeaderSubtitle>
      </Box>
    </NoActionsHeader>
  ) : null;
};

export default NoQuickAction;
